import api, { V2 } from './axios';
import { getDevice } from '@/lib/anonId';

export interface ChatConfig {
  enabled: boolean;
  anon_limit: number;
  user_limit: number;
  greeting: string;
  suggested_prompts: string[];
  disclaimer: string;
}

export interface ChatQuota {
  scope: string;
  limit: number;
  used: number;
  remaining: number;
  anonymous: boolean;
  reset_at?: string;
}

export const aiApi = {
  getConfig: () => api.get<ChatConfig>(`${V2}chat/config/`),
  getQuota: async () => {
    const d = await getDevice();
    return api.get<ChatQuota>(`${V2}chat/quota/`, {
      params: { device_id: d.id, device_token: d.token },
    });
  },
  /** User-initiated erasure: the server drops the transcript, not just the tab. */
  deleteSession: async (sessionId: string) => {
    const d = await getDevice();
    return api.post(`${V2}chat/sessions/delete/`, {
      session_id: sessionId,
      device_id: d.id,
      device_token: d.token,
    });
  },
  claimSession: async (sessionId: string) => {
    const d = await getDevice();
    return api.post(`${V2}chat/sessions/claim/`, {
      session_id: sessionId,
      device_id: d.id,
      device_token: d.token,
    });
  },
};
